import React from 'react'
import Home from './Home'
import Layout from '../../common/Layout'
import { fetchKnowsHowMuchToInvestOptions } from '../../features/FindAnIndependantFinancialAdviser/InvestmentAmountContainer/investmentAmountContainerActions'
import { fetchLanguages } from '../../features/FindAnIndependantFinancialAdviser/PreferredLanguagesContainer/preferredLanguagesContainerActions'
import { fetchFinancialServices } from '../../features/FindAnIndependantFinancialAdviser/FinancialServicesContainer/financialServicesContainerActions'

export default {
  path: '/',

  async action ({ store }) {
    // Fetch all required data for SSR
    if (store) {
      const promises = [
        store.dispatch(fetchKnowsHowMuchToInvestOptions()),
        store.dispatch(fetchLanguages()),
        store.dispatch(fetchFinancialServices())
      ]
      await Promise.all(promises)
    }

    return {
      title: 'Allan Gray | Find An Independent Financial Adviser',
      component: <Layout containerWell><Home /></Layout>
    }
  }
}
